export * from './src/portfolio-portfolio-app-v1-portfolio-settings-portfolio-settings.meta.js';
